import { Directive, HostListener } from '@angular/core';

@Directive({
  selector: '[appAlphabetsAndSpaceOnly]',
  standalone: true
})
export class AlphabetsAndSpaceOnlyDirective {

  constructor() { }

  @HostListener('keydown', ['$event'])
  onKeyDown(event: KeyboardEvent): void {
    // Regular expression to allow only English letters, Arabic letters, and spaces
    const allowedRegex = /^[A-Za-z\u0600-\u06FF\s]*$/;
    const key = event.key;

    // If the key doesn't match the allowed characters and is not 'Backspace' or 'Delete', prevent the input
    if (!allowedRegex.test(key) && key !== 'Backspace' && key !== 'Delete') {
      event.preventDefault();
    }
  }

}
